import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=251f1a33&scoped=true&"
import script from "./addressBook.js?vue&type=script&lang=js&"
export * from "./addressBook.js?vue&type=script&lang=js&"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=251f1a33&prod&scoped=true&lang=css&"
import style1 from "./addressBook.vue?vue&type=style&index=1&id=251f1a33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f1a33",
  null
  
)

export default component.exports